import React, { memo } from 'react';
import Select from 'components/Select';
import PropTypes from 'prop-types';

import ErrorMessage from 'components/ErrorMessage';

const SelectInput = ({
  testId,
  label,
  name,
  isDisabled,
  options,
  placeholder,
  error,
  labelClassName,
  inputWrapperClassName,
  inputBelowLabel,
  ...rest
}) => {
  return (
    <div data-testid={testId}>
      <label
        htmlFor={name}
        className={
          inputBelowLabel
            ? 'mb-4 block lg:mb-2'
            : 'mb-4 flex flex-1 flex-col lg:flex-row lg:items-center'
        }
      >
        <span
          className={`label ${
            inputBelowLabel
              ? 'text-opacity-80'
              : `pb-1 lg:pb-0 ${labelClassName}`
          }`}
        >
          {label}
        </span>
        <div className={inputWrapperClassName}>
          <Select
            {...rest}
            inputId={name}
            options={options}
            placeholder={placeholder}
            className="select-input"
            hasError={!!error}
            isDisabled={isDisabled}
          />
          {!!error && !inputBelowLabel && <ErrorMessage message={error} />}
        </div>
      </label>
      {!!error && inputBelowLabel && (
        <ErrorMessage message={error} className="-mt-3 lg:-mt-1" />
      )}
    </div>
  );
};

SelectInput.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})),
  testId: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isDisabled: PropTypes.bool,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  labelClassName: PropTypes.string,
  inputWrapperClassName: PropTypes.string,
  inputBelowLabel: PropTypes.bool,
};
SelectInput.defaultProps = {
  options: [],
  testId: 'select-input',
  label: '',
  isDisabled: false,
  placeholder: null,
  error: null,
  labelClassName: 'lg:w-4/12',
  inputWrapperClassName: 'flex-1',
  inputBelowLabel: true,
};

export default memo(SelectInput);
